// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i3l-","badges":"styles_badges__2WatY"};